import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {
    livenessChecks: [],
    currentLivenessCheck: null,
  },
  getters: {
    livenessChecks: (state) => state.livenessChecks,
    currentLivenessCheck: (state) => state.currentLivenessCheck,
  },
  mutations: {
    SET_LIVENESS_CHECKS: (state, livenessChecks) => {
      state.livenessChecks = livenessChecks;
    },
    SET_CURRENT_LIVENESS_CHECK: (state, livenessCheck) => {
      state.currentLivenessCheck = livenessCheck;
    },
  },
  actions: {
    fetchLivenessChecks({ commit }, params) {
      return axiosIns
        .get("/drivers/liveness-check", { params })
        .then((response) => {
          const data = response.data.data.data
          const total = response.data.data.total
          commit("SET_LIVENESS_CHECKS", data);
          return {
            data,
            total,
          };
        });
    },
    fetchLivenessCheckById({ commit }, id) {
      return axiosIns.get(`/drivers/liveness-check/${id}`).then((response) => {
        const data = response.data.data || response.data;
        commit("SET_CURRENT_LIVENESS_CHECK", data);
        return data;
      });
    },
  },
};
